<!--
  Vue wrapper for Bryntum GridBase
-->

<template>
    <div>
        <!-- Container for Vue components used in cells, hidden from view -->
        <div
            ref   = "cellInstancesHolder"
            style = "display: none"
        >
            <component
                :is    = "component.is"
                v-for  = "component in cellInstances"
                :ref   = "component.key"
                :key   = "component.key"
                v-bind = "component"
            />
        </div>
    </div>
</template>

<script>

import { Base, GridBase, Layout, Mask, Model, Rectangle, ScrollManager, Scroller, Store, Widget } from '@bryntum/scheduler';

import { StringHelper } from '@bryntum/scheduler';
import WrapperHelper from './WrapperHelper.js';
import WrapperHelperVue2 from './WrapperHelperVue2.js';

export default {

    name : 'BryntumGridBase',

    props : {

         // Configs only
        adopt                         : { type : [HTMLElement, String], default : undefined },
        align                         : { type : [Object, String], default : undefined },
        anchor                        : { type : Boolean, default : undefined },
        animateRemovingRows           : { type : Boolean, default : undefined },
        appendTo                      : { type : [HTMLElement, String], default : undefined },
        autoHeight                    : { type : Boolean, default : undefined },
        bbar                          : { type : [Array, Object], default : undefined },
        bodyCls                       : { type : [String, Object], default : undefined },
        bubbleEvents                  : { type : Object, default : undefined },
        centered                      : { type : Boolean, default : undefined },
        cls                           : { type : [String, Object], default : undefined },
        columns                       : { type : [Array, Object], default : undefined },
        config                        : { type : Object, default : undefined },
        constrainTo                   : { type : [HTMLElement, Widget, Rectangle], default : undefined },
        contentElementCls             : { type : [String, Object], default : undefined },
        contextMenuTriggerEvent       : { type : String, default : undefined },
        defaultBindProperty           : { type : String, default : undefined },
        defaultRegion                 : { type : String, default : undefined },
        defaults                      : { type : Object, default : undefined },
        destroyStore                  : { type : Boolean, default : undefined },
        disableGridRowModelWarning    : { type : Boolean, default : undefined },
        dock                          : { type : String, default : undefined },
        draggable                     : { type : [Boolean, Object], default : undefined },
        emptyText                     : { type : String, default : undefined },
        enableSticky                  : { type : Boolean, default : undefined },
        enableTextSelection           : { type : Boolean, default : undefined },
        enableUndoRedoKeys            : { type : Boolean, default : undefined },
        features                      : { type : Object, default : undefined },
        fillLastColumn                : { type : Boolean, default : undefined },
        fixedRowHeight                : { type : Boolean, default : undefined },
        floating                      : { type : Boolean, default : undefined },
        footer                        : { type : [Object, String], default : undefined },
        fullRowRefresh                : { type : Boolean, default : undefined },
        getRowHeight                  : { type : Function, default : undefined },
        header                        : { type : [String, Object], default : undefined },
        hideAnimation                 : { type : [Boolean, Object], default : undefined },
        hideHeaders                   : { type : Boolean, default : undefined },
        hideWhenEmpty                 : { type : Boolean, default : undefined },
        htmlCls                       : { type : [String, Object], default : undefined },
        insertBefore                  : { type : [HTMLElement, String], default : undefined },
        insertFirst                   : { type : [HTMLElement, String], default : undefined },
        itemCls                       : { type : String, default : undefined },
        lazyItems                     : { type : [Object, Array], default : undefined },
        listeners                     : { type : Object, default : undefined },
        loadMask                      : { type : [String, Object, null], default : undefined },
        loadMaskDefaults              : { type : [Object, Mask], default : undefined },
        loadMaskError                 : { type : [Object, Mask], default : undefined },
        localeClass                   : { type : Base, default : undefined },
        localizableProperties         : { type : Array, default : undefined },
        longPressTime                 : { type : Number, default : undefined },
        maskDefaults                  : { type : [Object, Mask], default : undefined },
        masked                        : { type : [Boolean, String, Object, Mask], default : undefined },
        monitorResize                 : { type : Boolean, default : undefined },
        namedItems                    : { type : Object, default : undefined },
        owner                         : { type : Widget, default : undefined },
        plugins                       : { type : Array, default : undefined },
        positioned                    : { type : Boolean, default : undefined },
        preserveFocusOnDatasetChange  : { type : Boolean, default : undefined },
        preserveScrollOnDatasetChange : { type : Boolean, default : undefined },
        preventTooltipOnTouch         : { type : Boolean, default : undefined },
        resizeToFitIncludesHeader     : { type : Boolean, default : undefined },
        responsiveLevels              : { type : Object, default : undefined },
        ripple                        : { type : [Boolean, Object], default : undefined },
        rootElement                   : { type : ShadowRoot, default : undefined },
        scrollAction                  : { type : String, default : undefined },
        scrollerClass                 : { type : Scroller, default : undefined },
        scrollManager                 : { type : [Object, ScrollManager], default : undefined },
        selectionMode                 : { type : Object, default : undefined },
        showAnimation                 : { type : [Boolean, Object], default : undefined },
        showDirty                     : { type : Boolean, default : undefined },
        showRemoveRowInContextMenu    : { type : Boolean, default : undefined },
        strips                        : { type : Object, default : undefined },
        subGridConfigs                : { type : Object, default : undefined },
        syncMask                      : { type : [String, Object, null], default : undefined },
        tab                           : { type : [Boolean, Object], default : undefined },
        tag                           : { type : String, default : undefined },
        tbar                          : { type : [Array, Object], default : undefined },
        textAlign                     : { type : String, default : undefined },
        textContent                   : { type : Boolean, default : undefined },
        title                         : { type : String, default : undefined },
        trapFocus                     : { type : Boolean, default : undefined },
        weight                        : { type : Number, default : undefined },

         // Configs and properties
        alignSelf          : { type : String, default : undefined },
        columnLines        : { type : Boolean, default : undefined },
        content            : { type : String, default : undefined },
        data               : { type : Array, default : undefined },
        dataset            : { type : Object, default : undefined },
        disabled           : { type : Boolean, default : undefined },
        extraData          : { type : [String, Number, Boolean, Object], default : undefined },
        flex               : { type : [Number, String], default : undefined },
        height             : { type : [Number, String], default : undefined },
        hidden             : { type : Boolean, default : undefined },
        html               : { type : String, default : undefined },
        id                 : { type : String, default : undefined },
        items              : { type : [Array, Object], default : undefined },
        layout             : { type : [Layout, String], default : undefined },
        layoutStyle        : { type : Object, default : undefined },
        margin             : { type : [Number, String], default : undefined },
        maxHeight          : { type : [String, Number], default : undefined },
        maxWidth           : { type : [String, Number], default : undefined },
        minHeight          : { type : [String, Number], default : undefined },
        minWidth           : { type : [String, Number], default : undefined },
        readOnly           : { type : Boolean, default : undefined },
        rowHeight          : { type : Number, default : undefined },
        scrollable         : { type : [Scroller, Boolean, Object], default : undefined },
        store              : { type : [Store, Object], default : undefined },
        tools              : { type : Object, default : undefined },
        tooltip            : { type : [String, Object], default : undefined },
        transitionDuration : { type : Number, default : undefined },
        width              : { type : [Number, String], default : undefined },
        x                  : { type : Number, default : undefined },
        y                  : { type : Number, default : undefined },

         // Properties only
        anchorSize      : { type : Array, default : undefined },
        isSettingValues : { type : Boolean, default : undefined },
        isValid         : { type : Boolean, default : undefined },
        record          : { type : Model, default : undefined },
        selectedCell    : { type : Object, default : undefined },
        selectedRecord  : { type : Model, default : undefined },
        selectedRecords : { type : Array, default : undefined },
        state           : { type : Object, default : undefined },
        values          : { type : Object, default : undefined },

         // Events
        onBeforeCellEditStart         : { type : Function, default : undefined },
        onBeforeDestroy               : { type : Function, default : undefined },
        onBeforeExport                : { type : Function, default : undefined },
        onBeforeFinishCellEdit        : { type : Function, default : undefined },
        onBeforeHide                  : { type : Function, default : undefined },
        onBeforeRenderRows            : { type : Function, default : undefined },
        onBeforeSetRecord             : { type : Function, default : undefined },
        onBeforeShow                  : { type : Function, default : undefined },
        onBeforeToggleNode            : { type : Function, default : undefined },
        onCancelCellEdit              : { type : Function, default : undefined },
        onCatchAll                    : { type : Function, default : undefined },
        onCellClick                   : { type : Function, default : undefined },
        onCellContextMenu             : { type : Function, default : undefined },
        onCellContextMenuBeforeShow   : { type : Function, default : undefined },
        onCellContextMenuShow         : { type : Function, default : undefined },
        onCellDblClick                : { type : Function, default : undefined },
        onCellMenuBeforeShow          : { type : Function, default : undefined },
        onCellMenuItem                : { type : Function, default : undefined },
        onCellMenuShow                : { type : Function, default : undefined },
        onCellMenuToggleItem          : { type : Function, default : undefined },
        onCellMouseOut                : { type : Function, default : undefined },
        onCellMouseOver               : { type : Function, default : undefined },
        onCollapseNode                : { type : Function, default : undefined },
        onContextMenuItem             : { type : Function, default : undefined },
        onContextMenuToggleItem       : { type : Function, default : undefined },
        onDestroy                     : { type : Function, default : undefined },
        onExpandNode                  : { type : Function, default : undefined },
        onExport                      : { type : Function, default : undefined },
        onFinishCellEdit              : { type : Function, default : undefined },
        onFocusIn                     : { type : Function, default : undefined },
        onFocusOut                    : { type : Function, default : undefined },
        onHeaderContextMenuBeforeShow : { type : Function, default : undefined },
        onHeaderContextMenuShow       : { type : Function, default : undefined },
        onHeaderMenuBeforeShow        : { type : Function, default : undefined },
        onHeaderMenuItem              : { type : Function, default : undefined },
        onHeaderMenuShow              : { type : Function, default : undefined },
        onHeaderMenuToggleItem        : { type : Function, default : undefined },
        onHide                        : { type : Function, default : undefined },
        onMouseOut                    : { type : Function, default : undefined },
        onMouseOver                   : { type : Function, default : undefined },
        onPaint                       : { type : Function, default : undefined },
        onReadOnly                    : { type : Function, default : undefined },
        onRenderRows                  : { type : Function, default : undefined },
        onResize                      : { type : Function, default : undefined },
        onResponsive                  : { type : Function, default : undefined },
        onScroll                      : { type : Function, default : undefined },
        onSelectionChange             : { type : Function, default : undefined },
        onShow                        : { type : Function, default : undefined },
        onStartCellEdit               : { type : Function, default : undefined },
        onToggleNode                  : { type : Function, default : undefined },
        onToolClick                   : { type : Function, default : undefined },

         // Features
        cellEditFeature   : { type : [Object, Boolean, String], default : undefined },
        cellMenuFeature   : { type : [Object, Boolean, String], default : undefined },
        cellTooltipFeature : { type : [Object, Boolean, String], default : undefined },
        columnAutoWidthFeature : { type : [Object, Boolean, String], default : undefined },
        columnDragToolbarFeature : { type : [Object, Boolean, String], default : undefined },
        columnPickerFeature : { type : [Object, Boolean, String], default : undefined },
        columnReorderFeature : { type : [Object, Boolean, String], default : undefined },
        columnResizeFeature : { type : [Object, Boolean, String], default : undefined },
        contextMenuFeature : { type : [Object, Boolean, String], default : undefined },
        excelExporterFeature : { type : [Object, Boolean, String], default : undefined },
        filterFeature     : { type : [Object, Boolean, String], default : undefined },
        filterBarFeature  : { type : [Object, Boolean, String], default : undefined },
        groupFeature      : { type : [Object, Boolean, String], default : undefined },
        groupSummaryFeature : { type : [Object, Boolean, String], default : undefined },
        headerMenuFeature : { type : [Object, Boolean, String], default : undefined },
        pdfExportFeature  : { type : [Object, Boolean, String], default : undefined },
        quickFindFeature  : { type : [Object, Boolean, String], default : undefined },
        regionResizeFeature : { type : [Object, Boolean, String], default : undefined },
        rowCopyPasteFeature : { type : [Object, Boolean, String], default : undefined },
        rowReorderFeature : { type : [Object, Boolean, String], default : undefined },
        searchFeature     : { type : [Object, Boolean, String], default : undefined },
        sortFeature       : { type : [Object, Boolean, String], default : undefined },
        stickyCellsFeature : { type : [Object, Boolean, String], default : undefined },
        stripeFeature     : { type : [Object, Boolean, String], default : undefined },
        summaryFeature    : { type : [Object, Boolean, String], default : undefined },
        treeFeature       : { type : [Object, Boolean, String], default : undefined },

    },

    data : () => {
        return {
            instanceClass : GridBase,

            isView : true,

            cellInstances : [],

            dataStores : {},

            featureNames : [
                'cellEditFeature',
                'cellMenuFeature',
                'cellTooltipFeature',
                'columnAutoWidthFeature',
                'columnDragToolbarFeature',
                'columnPickerFeature',
                'columnReorderFeature',
                'columnResizeFeature',
                'contextMenuFeature',
                'excelExporterFeature',
                'filterFeature',
                'filterBarFeature',
                'groupFeature',
                'groupSummaryFeature',
                'headerMenuFeature',
                'pdfExportFeature',
                'quickFindFeature',
                'regionResizeFeature',
                'rowCopyPasteFeature',
                'rowReorderFeature',
                'searchFeature',
                'sortFeature',
                'stickyCellsFeature',
                'stripeFeature',
                'summaryFeature',
                'treeFeature'
            ],

            configNames : [
                'adopt',
                'align',
                'anchor',
                'animateRemovingRows',
                'appendTo',
                'autoHeight',
                'bbar',
                'bodyCls',
                'bubbleEvents',
                'centered',
                'cls',
                'columns',
                'config',
                'constrainTo',
                'contentElementCls',
                'contextMenuTriggerEvent',
                'defaultBindProperty',
                'defaultRegion',
                'defaults',
                'destroyStore',
                'disableGridRowModelWarning',
                'dock',
                'draggable',
                'emptyText',
                'enableSticky',
                'enableTextSelection',
                'enableUndoRedoKeys',
                'features',
                'fillLastColumn',
                'fixedRowHeight',
                'floating',
                'footer',
                'fullRowRefresh',
                'getRowHeight',
                'header',
                'hideAnimation',
                'hideHeaders',
                'hideWhenEmpty',
                'htmlCls',
                'insertBefore',
                'insertFirst',
                'itemCls',
                'lazyItems',
                'listeners',
                'loadMask',
                'loadMaskDefaults',
                'loadMaskError',
                'localeClass',
                'localizableProperties',
                'longPressTime',
                'maskDefaults',
                'masked',
                'monitorResize',
                'namedItems',
                'owner',
                'plugins',
                'positioned',
                'preserveFocusOnDatasetChange',
                'preserveScrollOnDatasetChange',
                'preventTooltipOnTouch',
                'resizeToFitIncludesHeader',
                'responsiveLevels',
                'ripple',
                'rootElement',
                'scrollAction',
                'scrollerClass',
                'scrollManager',
                'selectionMode',
                'showAnimation',
                'showDirty',
                'showRemoveRowInContextMenu',
                'strips',
                'subGridConfigs',
                'syncMask',
                'tab',
                'tag',
                'tbar',
                'textAlign',
                'textContent',
                'title',
                'trapFocus',
                'weight'
            ],

            propertyConfigNames : [
                'alignSelf',
                'columnLines',
                'content',
                'data',
                'dataset',
                'disabled',
                'extraData',
                'flex',
                'height',
                'hidden',
                'html',
                'id',
                'items',
                'layout',
                'layoutStyle',
                'margin',
                'maxHeight',
                'maxWidth',
                'minHeight',
                'minWidth',
                'onBeforeCellEditStart',
                'onBeforeDestroy',
                'onBeforeExport',
                'onBeforeFinishCellEdit',
                'onBeforeHide',
                'onBeforeRenderRows',
                'onBeforeSetRecord',
                'onBeforeShow',
                'onBeforeToggleNode',
                'onCancelCellEdit',
                'onCatchAll',
                'onCellClick',
                'onCellContextMenu',
                'onCellContextMenuBeforeShow',
                'onCellContextMenuShow',
                'onCellDblClick',
                'onCellMenuBeforeShow',
                'onCellMenuItem',
                'onCellMenuShow',
                'onCellMenuToggleItem',
                'onCellMouseOut',
                'onCellMouseOver',
                'onCollapseNode',
                'onContextMenuItem',
                'onContextMenuToggleItem',
                'onDestroy',
                'onExpandNode',
                'onExport',
                'onFinishCellEdit',
                'onFocusIn',
                'onFocusOut',
                'onHeaderContextMenuBeforeShow',
                'onHeaderContextMenuShow',
                'onHeaderMenuBeforeShow',
                'onHeaderMenuItem',
                'onHeaderMenuShow',
                'onHeaderMenuToggleItem',
                'onHide',
                'onMouseOut',
                'onMouseOver',
                'onPaint',
                'onReadOnly',
                'onRenderRows',
                'onResize',
                'onResponsive',
                'onScroll',
                'onSelectionChange',
                'onShow',
                'onStartCellEdit',
                'onToggleNode',
                'onToolClick',
                'readOnly',
                'rowHeight',
                'scrollable',
                'store',
                'tools',
                'tooltip',
                'transitionDuration',
                'width',
                'x',
                'y'
            ],

            propertyNames : [
                'anchorSize',
                'isSettingValues',
                'isValid',
                'record',
                'selectedCell',
                'selectedRecord',
                'selectedRecords',
                'state',
                'values'
            ],

            eventNames : [
                'beforeCellEditStart',
                'beforeDestroy',
                'beforeExport',
                'beforeFinishCellEdit',
                'beforeHide',
                'beforeRenderRows',
                'beforeSetRecord',
                'beforeShow',
                'beforeToggleNode',
                'cancelCellEdit',
                'catchAll',
                'cellClick',
                'cellContextMenu',
                'cellContextMenuBeforeShow',
                'cellContextMenuShow',
                'cellDblClick',
                'cellMenuBeforeShow',
                'cellMenuItem',
                'cellMenuShow',
                'cellMenuToggleItem',
                'cellMouseOut',
                'cellMouseOver',
                'collapseNode',
                'contextMenuItem',
                'contextMenuToggleItem',
                'destroy',
                'expandNode',
                'export',
                'finishCellEdit',
                'focusIn',
                'focusOut',
                'headerContextMenuBeforeShow',
                'headerContextMenuShow',
                'headerMenuBeforeShow',
                'headerMenuItem',
                'headerMenuShow',
                'headerMenuToggleItem',
                'hide',
                'mouseOut',
                'mouseOver',
                'paint',
                'renderRows',
                'resize',
                'responsive',
                'scroll',
                'selectionChange',
                'show',
                'startCellEdit',
                'toggleNode',
                'toolClick'
            ]
        };
    },

    /**
     * Called after the instance has been mounted
     */
    mounted() {
        const
            me = this,
            {
                createWidget,
                relayStores,
                watchProps
            }  = WrapperHelper(),
            {
                processCellContent,
                hasFrameworkRenderer
            }  = WrapperHelperVue2();

        me.instance = createWidget({
            me,
            props                : me.$props,
            data                 : me.$data,
            listeners            : me.$listeners,
            emit                 : me.$emit.bind(me),
            element              : me.$el,
            processCellContent   : processCellContent.bind(me),
            hasFrameworkRenderer : hasFrameworkRenderer.bind(me)
        });
        // Backwards compatibility for gridInstance, schedulerInstance etc.
        me[StringHelper.uncapitalize(me.instanceClass.$name) + 'Instance'] = me.instance;
        relayStores(me.$data, me.instance);

        const watcher = me.$watch.bind(me);
        watchProps(me, me.instance, me.$props, me.$data, watcher);
    },

    /**
     * Called right before a Vue instance is destroyed. At this stage the instance is still fully functional.
     */
    beforeDestroy() {
        if (this.instance) {
            this.instance.destroy();
        }
    }

};

</script>
